import React from "react";
import Header from "./Header";
import PoweredBy from "./PoweredBy";
import {VerificationCompleteIcon} from "../icons/VerificationCompleteIcon";

function VerificationComplete({message}) {
    return (
        <div className="flex flex-col w-full h-full">
            <Header closeEnabled={false}/>
            <div className="flex flex-col p-4 w-full h-full justify-center">
                <div className="flex flex-col items-center gap-5">
                    <VerificationCompleteIcon height={250} width={200}/>
                    <div className="font-bold text-2xl gradient-text">{message}</div>
                </div>
            </div>
            <div className="flex flex-row justify-center p-4">
                <PoweredBy/>
            </div>
        </div>

    );
}

export default VerificationComplete;
